module.exports = __webpack_public_path__ + "static/menglong_guo-fc23ba775c0325d76d1b0c2be95f76b8.jpg";